import React, {useContext, useState, useEffect, useRef} from 'react'
import LottoService from "../../Services/Lotto.service";
import DataContext from "../../data/DataContext";
import {empty, unInteger} from "../../Common/Util/functions";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import Swal from "sweetalert2";
import axios from "axios";

function LottoWin() {
  const lottoService = new LottoService();
  const dataConf = useContext(DataContext)

  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const firstUpdate = useRef(true);
  useEffect(()=>{
   /* if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }*/
    loadListing()
  },[])

  const loadListing = () =>
  {
    if(loading){
      return;
    }

    dataConf.blockUI(true);
    setLoading(true);
    lottoService.listing().then((result) => {
      if (result.success){
        setList(result.data);
      }
      else{
        Swal.fire({
          title: result.message,
          text:'',
          icon: 'warning',
          confirmButtonText: 'ตกลง',
          confirmButtonColor: '#890000',
        })
      }
      dataConf.blockUI()
      setLoading(false);
    });
  }

  const setLotto = (e, id) =>
  {
    e.preventDefault();
    if(submitting){
      return;
    }

    const model = {
      p_ok_id: id,
      p_ok_number: getOKNumber(e)
    }
    dataConf.blockUI(true)
    setSubmitting(true);
    lottoService.result(model).then((result) => {
      if (result.success){
        // setList(result.data);
        loadListing()
        Swal.fire({
          title: result.message,
          text:'',
          icon: 'success',
          confirmButtonText: 'ตกลง',
          confirmButtonColor: 'green',
        })
      }
      else{
        Swal.fire({
          title: result.message,
          text:'',
          icon: 'warning',
          confirmButtonText: 'ตกลง',
          confirmButtonColor: '#890000',
        })
      }
      dataConf.blockUI()
      setSubmitting(false);
    });
  }

  const getOKNumber = (e) =>
  {
    return `${e.target.t3u.value},${e.target.t2d.value},${e.target.t3d1.value},${e.target.t3d2.value},${e.target.t3d3.value},${e.target.t3d4.value}`;
  }

  const activeReBill = (id, open:boolean = false) =>
  {
    const newState = list.map(obj => {
      if (obj._id === id) {
        return {...obj, re_bill: open};
      }
      return obj;
    });
    setList(newState);
  }

  const reBill = (event,row)=>{
    event.preventDefault();
    if(submitting){
      return;
    }

    Swal.fire({
      title: 'รหัสความปลอดภัย',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'ตกลง',
      showLoaderOnConfirm: true,
      cancelButtonText: 'ยกเลิก',
      preConfirm: (pass_code) => {
        if(pass_code === "") {
          Swal.fire('ผิดพลาด', "รหัสความปลอดภัยไม่ถูกต้อง")
          return;
        }

        const model = {
          p_ok_id: row._id,
          p_a_id: dataConf.a_id,
          p_g_process: row.g_process,
          p_code: pass_code,
          p_ok_number: getOKNumber(event)
        }
        dataConf.blockUI(true)
        setSubmitting(true);
        lottoService.reBill(model).then((result) => {
          if (result.success){
            Swal.fire({
              title: result.message,
              text:'',
              icon: 'success',
              confirmButtonText: 'ตกลง',
              confirmButtonColor: 'green',
            })

            activeReBill(row._id);
          }
          else{
            Swal.fire({
              title: result.message,
              text:'',
              icon: 'warning',
              confirmButtonText: 'ตกลง',
              confirmButtonColor: '#890000',
            })
          }
          dataConf.blockUI()
          setSubmitting(false);
        });
      }
    })
  }

  const datetimeControl = (e, id, isLimitTimeSmall:boolean = false)=>{
    e.preventDefault();
    if(submitting){
      return;
    }
    Swal.fire({
      title: 'ยืนยัน',
      text: `คุณต้องการเปลี่ยนแปลงวันที่ปิด${isLimitTimeSmall ? 'ล่าง' : 'รับ' }หรือไม่`,
      showCancelButton: true,
      confirmButtonText: 'ตกลง',
      showLoaderOnConfirm: true,
      cancelButtonText: 'ยกเลิก',
    }).then((result) => {
      if (result.isConfirmed) {
        dataConf.blockUI(true)
        setSubmitting(true);
        const model = {
          p_id: id
        };

        if(isLimitTimeSmall){
          model.p_limit_time_small_th = e.target.input_date_small_limit.value;
        }
        else {
          model.p_limit_time_th = e.target.input_date_limit.value;
        }

        lottoService.control(model).then((result) => {
          if (result.success){
            Swal.fire({
              title: result.message,
              text:'',
              icon: 'success',
              confirmButtonText: 'ตกลง',
              confirmButtonColor: 'green',
            })
          }
          else{
            Swal.fire({
              title: result.message,
              text:'',
              icon: 'warning',
              confirmButtonText: 'ตกลง',
              confirmButtonColor: '#890000',
            })
          }
          dataConf.blockUI()
          setSubmitting(false);
        });
      }
    })
  }

  const setStatusLotto = (id, status:number = 0) =>
  {
    if(submitting){
      return;
    }
    Swal.fire({
      title: 'ยืนยัน',
      text: `คุณต้องการ ${status ? 'เปิด' : 'ปิด' }หวยนี้หรือไม่`,
      showCancelButton: true,
      confirmButtonText: 'ตกลง',
      showLoaderOnConfirm: true,
      cancelButtonText: 'ยกเลิก',
    }).then((result) => {
      if (result.isConfirmed) {
        dataConf.blockUI(true)
        setSubmitting(true);
        const model = {
          p_id: id,
          p_status: status
        };
        lottoService.control(model).then((result) => {
          if (result.success){
            Swal.fire({
              title: result.message,
              text:'',
              icon: 'success',
              confirmButtonText: 'ตกลง',
              confirmButtonColor: 'green',
            })

            const newState = list.map(obj => {
              if (obj._id === id) {
                return {...obj, status: status};
              }
              return obj;
            });
            setList(newState);
          }
          else{
            Swal.fire({
              title: result.message,
              text:'',
              icon: 'warning',
              confirmButtonText: 'ตกลง',
              confirmButtonColor: '#890000',
            })
          }
          dataConf.blockUI()
          setSubmitting(false);
        });
      }
    })
  }

  const loadProcess = async (row) =>
  {
    const response = await axios.post(
        `${dataConf.ApiFrontEnd}/sa/access-key`,
        {
          username: dataConf.a_user,
          password: dataConf.a_pass
        },
        {
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json'
          }
        }
    ).then((res)=>{

      Swal.fire({
        title: 'ยืนยัน',
        text: 'คุณต้องการคำนวนผลรางวัลนี้หรือไม่',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        showLoaderOnConfirm: true,
        cancelButtonText: 'ยกเลิก',
      }).then((result) => {
        if (result.isConfirmed) {
          dataConf.blockUI(true)
          setSubmitting(true);

          const model = {
            p_ok_id: row._id,
            p_a_id: dataConf.a_id,
            p_access_key: res.data.key,
            p_zone: row.zone,
            p_g_proccess: row.g_process
          }

          lottoService.process(model).then((result) => {
            if (result.success){
              Swal.fire({
                title: result.message,
                text:'',
                icon: 'success',
                confirmButtonText: 'ตกลง',
                confirmButtonColor: 'green',
              })
            }
            else{
              Swal.fire({
                title: result.message,
                text:'',
                icon: 'warning',
                confirmButtonText: 'ตกลง',
                confirmButtonColor: '#890000',
              })
            }
            dataConf.blockUI()
            setSubmitting(false);
          });
        }
      })
    }).catch((error) => {
          // console.log(error)
          Swal.fire({
            title: error.response.data.message,
            text:'',
            icon: 'warning',
            confirmButtonText: 'ตกลง',
            confirmButtonColor: '#890000',
          })
        });
  }

  const getNumber = (data:string, arrayNumber:number) =>
  {
    if(empty(data)){
      return '';
    }

    const array = data.split(',');
    if(array.length > arrayNumber){
      return array[arrayNumber];
    }

    return '';
  }

  return (
    <div id="lotto-money" className="p-2">
      <div className="table-responsive">
      <table  className="table table-bordered ">
          <colgroup>
            <col width="15%"/>
            <col width="50%"/>
            <col width="20%"/>
            <col width="15%"/>
          </colgroup>
          <thead>
          <tr className="bg-title text-white">
            <th className="text-center" align="center" style={{minWidth:'250px'}}>No.</th>
            <th className="text-center" align="center" style={{minWidth:'350px'}}>ผลรางวัล</th>
            <th className="text-center" align="center" style={{minWidth:'250px'}}>วันที่ / ปิดรับ</th>
            <th className="text-center" align="center" style={{minWidth:'250px'}}>วันที่ / ปิดล่าง</th>
          </tr>
          </thead>
          <tbody>
          {list.map((row) =>
            <tr key={row._id}>
                  <td align="center">{row._id}</td>
                  <td>
                    {(row.active) ?
                        (
                            <form onSubmit={(e)=>reBill(e, row)} id="save_reward">
                              <div className="row">
                                <div className="col-8">
                                  <div className="row">
                                    <div className="col-xl-7">
                                      <div className="row mb-2">
                                        <span className="form-label col-lg-4 col-form-label">6 ตัว</span>
                                        <div className="col-lg-8">
                                          <input name="t3u" defaultValue={getNumber(row.ok_number,0)} id={`t3u_${row._id}`} onChange={(e)=>(unInteger(e.target,'value'))} className="form-control form-control-sm" type="text" autoComplete="off" size={10} maxLength={6} disabled={empty(row.re_bill)} required/>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-xl-7">
                                      <div className="row mb-2">
                                        <span className="form-label col-lg-4 col-form-label">2 ตัวล่าง</span>
                                        <div className="col-lg-8">
                                          <input name="t2d" defaultValue={getNumber(row.ok_number,1)} id={`t2d_${row._id}`} onChange={(e)=>(unInteger(e.target,'value'))} className="form-control form-control-sm" type="text" autoComplete="off" size={10} maxLength={2} disabled={empty(row.re_bill)} required/>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-xl-7">
                                      <div className="row mb-2">
                                        <span className="form-label col-lg-4 col-form-label">3 ล่างหน้า</span>
                                        <div className="col-lg-8">
                                          <div className="input-group">
                                            <input name="t3d1" defaultValue={getNumber(row.ok_number,2)} id={`t3d1_${row._id}`} onChange={(e)=>(unInteger(e.target,'value'))} className="form-control form-control-sm" type="text" autoComplete="off" size={5} maxLength={3} disabled={empty(row.re_bill)} required/>
                                            <input name="t3d2" defaultValue={getNumber(row.ok_number,3)} id={`t3d2_${row._id}`} onChange={(e)=>(unInteger(e.target,'value'))} className="form-control form-control-sm" type="text" autoComplete="off" size={5} maxLength={3} disabled={empty(row.re_bill)} required/>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-xl-5">
                                      <div className="row mb-2">
                                        <span className="form-label col-lg-4 col-form-label">3 ล่าง</span>
                                        <div className="col-lg-8">
                                          <div className="input-group">
                                            <input name="t3d3" defaultValue={getNumber(row.ok_number,4)} id={`t3d3_${row._id}`} className="form-control form-control-sm" type="text" autoComplete="off" size={5} maxLength={3} disabled={empty(row.re_bill)} required/>
                                            <input name="t3d4" defaultValue={getNumber(row.ok_number,5)} id={`t3d4_${row._id}`} onChange={(e)=>(unInteger(e.target,'value'))} className="form-control form-control-sm" type="text" autoComplete="off" size={5} maxLength={3} disabled={empty(row.re_bill)} required/>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-4 text-end">
                                  {(empty(row.re_bill)) &&<button onClick={()=>activeReBill(row._id, true)} type="button" className="btn btn-sm btn-success ms-1 mb-1">รีบิล</button>}
                                  <button type="button" className="btn btn-sm btn-outline-secondary ms-1 mb-1" disabled>จ่ายแล้ว</button>
                                  {(!empty(row.re_bill)) &&<button type="submit" className="btn btn-sm btn-warning ms-1 mb-1">คำนวณ</button>}
                                </div>
                              </div>
                            </form>
                        ):
                        (
                            <form onSubmit={(e)=>setLotto(e, row._id)} id="save_reward">
                              <div className="row">
                                <div className="col-8">
                                  <div className="row">
                                    <div className="col-xl-7">
                                      <div className="row mb-2">
                                        <span className="form-label col-lg-4 col-form-label">6 ตัว</span>
                                        <div className="col-lg-8">
                                          <input name="t3u" id={`t3u_${row._id}`} defaultValue={getNumber(row.ok_number,0)}  onChange={(e)=>(unInteger(e.target,'value'))} className="form-control form-control-sm" type="text" autoComplete="off" size={10} maxLength={6} required/>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-xl-7">
                                      <div className="row mb-2">
                                        <span className="form-label col-lg-4 col-form-label">2 ตัวล่าง</span>
                                        <div className="col-lg-8">
                                          <input name="t2d" id={`t2d_${row._id}`} defaultValue={getNumber(row.ok_number,1)}  onChange={(e)=>(unInteger(e.target,'value'))} className="form-control form-control-sm" type="text" autoComplete="off" size={10} maxLength={2} required/>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-xl-7">
                                      <div className="row mb-2">
                                        <span className="form-label col-lg-4 col-form-label">3 ล่างหน้า</span>
                                        <div className="col-lg-8">
                                          <div className="input-group">
                                            <input name="t3d1" id={`t3d1_${row._id}`} defaultValue={getNumber(row.ok_number,2)}  onChange={(e)=>(unInteger(e.target,'value'))} className="form-control form-control-sm" type="text" autoComplete="off" size={5} maxLength={3} required/>
                                            <input name="t3d2" id={`t3d2_${row._id}`} defaultValue={getNumber(row.ok_number,3)}  onChange={(e)=>(unInteger(e.target,'value'))} className="form-control form-control-sm" type="text" autoComplete="off" size={5} maxLength={3} required/>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-xl-5">
                                      <div className="row mb-2">
                                        <span className="form-label col-lg-4 col-form-label">3 ล่าง</span>
                                        <div className="col-lg-8">
                                          <div className="input-group">
                                            <input name="t3d3" id={`t3d3_${row._id}`} defaultValue={getNumber(row.ok_number,4)}  onChange={(e)=>(unInteger(e.target,'value'))} className="form-control form-control-sm" type="text" autoComplete="off" size={5} maxLength={3} required/>
                                            <input name="t3d4" id={`t3d4_${row._id}`} defaultValue={getNumber(row.ok_number,5)}  onChange={(e)=>(unInteger(e.target,'value'))} className="form-control form-control-sm" type="text" autoComplete="off" size={5} maxLength={3} required/>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-4 text-end">
                                  <div className="text-end">
                                    <div>
                                      <span className="text-danger">ตรวจผลก่อนกด ให้ดี</span>
                                    </div>
                                    <button type="submit" className="btn btn-sm btn-success ms-1 mb-1" disabled={submitting}>บันทึก</button>
                                    <button type="button" onClick={()=>loadProcess(row)} className="btn btn-sm btn-warning ms-1 mb-1">คำนวณ</button>
                                    {(row.status === 1) ? (<button onClick={()=>setStatusLotto(row._id, 0)} type="button" value="1" className="btn btn-sm btn-danger ms-1 mb-1">กดเพื่อปิด</button>) : (<button onClick={()=>setStatusLotto(row._id, 1)} type="button" value="1" className="btn btn-sm btn-success ms-1">กดเพื่อเปิด</button>)}
                                  </div>
                                </div>
                              </div>
                            </form>
                        )
                    }
                  </td>
                  <td>
                    <form onSubmit={(e)=>datetimeControl(e, row._id)} id="edit_datetime_control">
                    <DateRangePicker initialSettings={{timePicker: true,timePicker24Hour: true,timePickerSeconds:true,singleDatePicker:true, startDate: moment(row.limit_time), locale: {...dataConf.localSet,format: 'DD/MM/YYYY HH:mm'}}}>
                      <input type="text" className="form-control form-control-sm" id="input_date_limit" readOnly/>
                    </DateRangePicker>
                    {(empty(row.active)) &&
                      <div className="text-end mt-2">
                          <button type="submit" id="b_date_limit" className="btn btn-sm btn-warning">แก้ไข</button>
                      </div>
                    }
                    </form>
                  </td>
                  <td>
                    <form onSubmit={(e)=>datetimeControl(e, row._id, true)} id="edit_datetime_control">
                    <DateRangePicker initialSettings={{timePicker: true,timePicker24Hour: true,timePickerSeconds:true,singleDatePicker:true, startDate: moment(row.limit_time_small), locale: {...dataConf.localSet,format: 'DD/MM/YYYY HH:mm'}}}>
                      <input type="text" className="form-control form-control-sm" id="input_date_small_limit" readOnly/>
                    </DateRangePicker>
                    {(empty(row.active)) &&
                      <div className="text-end mt-2">
                        <button type="submit" id="b_date_small_limit" className="btn btn-sm btn-warning">แก้ไข</button>
                      </div>
                    }
                    </form>
                  </td>
              </tr>
            )}

          </tbody>
        </table>
      </div>
    </div>
  )
}

export default LottoWin